// extracted by mini-css-extract-plugin
export default {"text":"Typography_text__HiXc2"};